import {
  Autocomplete,
  Button,
  Container,
  MultiSelect,
  NumberInput,
  PasswordInput,
  Radio,
  Select,
  TextInput,
  Textarea,
  createTheme,
  Accordion,
  Modal,
} from '@mantine/core';
import { DatePickerInput, MonthPickerInput } from '@mantine/dates';
import radioClasses from '@/assets/styles/radio.module.css';
import inputClasses from '@/assets/styles/input.module.css';
import monthPickerInputClasses from '@/assets/styles/monthPickerInput.module.css';
import multiSelectClasses from '@/assets/styles/multiSelect.module.css';
import buttonClasses from '@/assets/styles/button.module.css';
import accordionClasses from '@/assets/styles/accordion.module.css';
import datePickerInputClasses from '@/assets/styles/datePicker.module.css';

const style = { backgroundColor: 'var(--mantine-color-gray-0)' };

const theme = createTheme({
  fontFamily: 'Rubik, Arial',
  black: '#333',
  cursorType: 'pointer',
  primaryColor: 'brand',
  colors: {
    brand: ['#D0E1F9', '#A9C4EB', '#7EA1D6', '#4F75B5', '#375A9E', '#253A71', '#253A71', '#1565C0', '#041E42', '#021B35', '#232873'],
    gray: ['#F8FAFC', '#F1F5F9', '#E2E8F0', '#CBD5E1', '#A6A8AD', '#64748B', '#475569', '#334155', '#1E293B', '#0F172A', '#6B6E77'],
    secondary: ['#A49343'],

  },
  components: {
    Autocomplete: Autocomplete.extend({
      styles: {
        input: style,
      },
      classNames: inputClasses,
    }),
    NumberInput: NumberInput.extend({
      styles: {
        input: style,
      },
      classNames: inputClasses,
    }),
    MultiSelect: MultiSelect.extend({
      styles: {
        input: style,
      },
      classNames: multiSelectClasses,
    }),
    TextInput: TextInput.extend({
      classNames: inputClasses,
    }),
    Textarea: Textarea.extend({
      styles: {
        input: style,
      },
      classNames: inputClasses,
    }),
    PasswordInput: PasswordInput.extend({
      styles: {
        input: style,
      },
      classNames: inputClasses,
    }),
    Select: Select.extend({
      styles: {
        input: style,
      },
      classNames: inputClasses,
    }),
    DatePickerInput: DatePickerInput.extend({
      styles: {
        input: style,
      },
      classNames: datePickerInputClasses,
    }),
    MonthPickerInput: MonthPickerInput.extend({
      styles: {
        input: style,
      },
      classNames: monthPickerInputClasses,
    }),
    Container: Container.extend({
      defaultProps: {
        px: 'lg',
      },
    }),
    Radio: Radio.extend({
      classNames: radioClasses,
    }),
    Button: Button.extend({
      classNames: buttonClasses,
    }),
    Accordion: Accordion.extend({
      classNames: accordionClasses,
    }),
    Modal: Modal.extend({
      styles: {
        content: {
          scrollbarWidth: 'none',
        },
      },
    }),
  },
  other: {
    menuWidth: '14rem',
    sideWidth: '24rem',
    headerHeight: '4rem',
    navbarWidth: '5rem',
    navbarWidthExpanded: '12rem',
  },
});

/**
 * add custom variables to mantine css
 * @param {object} t - mantine theme
 * @returns {object}
 */
const resolver = (t) => ({
  variables: {
    '--header-height': '5rem',
    '--navbar-width': t.other.navbarWidth,
    '--navbar-width-expanded': t.other.navbarWidthExpanded,
    '--page-menu-width': t.other.menuWidth,
    '--page-side-width': t.other.sideWidth,
  },
});

const dates = {
  locale: 'he',
  firstDayOfWeek: 0, // sunday
  timezone: 'Asia/Jerusalem',
  weekendDays: [5, 6],
};

export {
  theme,
  dates,
  resolver,
};
